module.exports = __webpack_public_path__ + "img/in-person-white.c758f5ae.svg";